/** @module Apparel/MaterialForm */
define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "underscore",
    "csi/def/Field",
    "csi/state",
    "csi/xml",
    "./_MaterialFormMixin"
], function (declare, lang, _, Field, state, xml, _MaterialFormMixin) {

    return declare(_MaterialFormMixin, {

        /*
         * @override
         */
        _resolveView: function () {

            // Add MaterialType field to form
            var f = lang.mixin(new Field(), {
                m_id: this.PRODUCT_TYPE
            });

            var sourceNode = this.defView.getSourceNode();
            if (sourceNode) {
                f.m_right = xml.RIGHT_NONE;

                if (sourceNode.Special || sourceNode.Hidden) {
                    // In case of PromoteSpecialMaterial, make the fields editable even with "Editable on Create Form Only" set to true
                    _.each(this.defView.m_fields, function (field) {
                        field.bForceEditable = true;
                    });
                }
            }

            if (state.get("userType") == "Supplier") {

                // In case of Supplier User, remove all fields except for Node Name, MSG, Code, and Description
                this.defView.m_fields = _.filter(this.defView.m_fields, function (field) {
                    return field.m_id == "Node Name" ||
                        field.m_id == "MaterialSecurityGroups" ||
                        field.m_id == "Code" ||
                        field.m_id == "Description"
                });
            }

            this.insertField(f, 0);

            this.inherited(arguments);
        },

        /*
         * Init MSG field if creating Material from MSG perspective
         */
        onViewCreate: function () {
            var fd = this.defView.m_formData;
            var parent = fd.getParent();
            if (parent) {

                if (parent.$Type == this.MATERIAL_SECURITY_GROUP) {
                    if (!this.getField(this.MATERIAL_SECURITY_GROUPS)) {
                        var f = lang.mixin(new Field(), {
                            m_id: this.MATERIAL_SECURITY_GROUPS
                        });
                        this.insertField(f, 0);
                    }
                    this.addFixedValue(this.MATERIAL_SECURITY_GROUPS, [parent.$URL]);
                } else if (parent.$Type == this.DOCUMENT) {
                    var material = this.cacheView.getPathNode(parent, "Child:__Parent__/Child:__Parent__");
                    if (material.MaterialSecurityGroups) {
                        if (!this.getField(this.MATERIAL_SECURITY_GROUPS)) {
                            var f = lang.mixin(new Field(), {
                                m_id: this.MATERIAL_SECURITY_GROUPS
                            });
                            this.insertField(f, 0);
                            this.addFixedValue(this.MATERIAL_SECURITY_GROUPS, material.MaterialSecurityGroups);
                        }
                    }
                }
            }
            this.inherited(arguments);
        },

        /**
         * @override
         * Update MSG field visibility
         */
        _updateFieldVisibility: function (/*Field*/field) {
            this.inherited(arguments);
            // if MSG field is on the form, disable it for copy action
            if (this.isCopy()) {
                this.setFieldDisabled(this.MATERIAL_SECURITY_GROUPS, true);
            }
            return true;
        }

    });
});

